import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CURRENCY_SIGN_MAP } from 'constants/currency';
import { DATE_FORMAT } from 'constants/date';

import { getFormattedDate } from 'helpers/date';
import { replaceUnderscoreToDash } from 'helpers/utils';

import { SUBSCRIPTION_LABEL_STATES } from '../constants';
import { IUpcomingProductProps } from '../types';

import BillingPeriod from './subComponents/BillingPeriod';
import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import PeriodRow from './subComponents/PeriodRow';
import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';

import * as S from './styled';

const UpcomingProduct = ({ upcomingProduct, isNextChargeAvailable, isUpgrade }: IUpcomingProductProps) => {
    const { t } = useTranslation();

    const autoRenewalDate = getFormattedDate(upcomingProduct.started_from as string, DATE_FORMAT);
    const price = upcomingProduct.price;

    const currencySign = CURRENCY_SIGN_MAP[upcomingProduct.currency] || upcomingProduct.currency;

    const period = upcomingProduct.subscription_period;

    return (
        <>
            <S.GeneralInfo $mb={16} $mt={24}>
                <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.UPCOMING} />
                <PeriodRow isTrial={false} period={period} />
                <S.SubscriptionCardRow>
                    <Text>{t('basics.price')}</Text>
                    <Text dataLocator="subscriptionPrice">{`${price} ${currencySign}`}</Text>
                </S.SubscriptionCardRow>
                <BillingPeriod period={period} />
                {isNextChargeAvailable && (
                    <S.SubscriptionCardRow>
                        <Text>{t('subscription.text.newChargeDate')}</Text>
                        <Text dataLocator="subscriptionNextChargeDate">{`${replaceUnderscoreToDash(autoRenewalDate)} UTC`}</Text>
                    </S.SubscriptionCardRow>
                )}
                {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            </S.GeneralInfo>
            <S.Line $mb={20} />
        </>
    );
};

export default UpcomingProduct;
